class PackbagsCustomiser extends HTMLElement {
  constructor() {
    super()

    this.flow = {
      currentStep: 0,
      totalSteps: 2,
    }

    this.b2b = false

    this.ui = {
      header: document.querySelector('packbags-header'),
      splashScreen: this.querySelector('customiser-splash'),
      assemble: this.querySelector('customiser-assemble'),
      end: this.querySelector('customiser-end'),
    }

    this.finalSelection = []

    this.base = null
  }

  async connectedCallback() {
    if (window.spark) {
      this.b2b = await window.spark.isLoggedIn()
    }
  }

  hideLoadingScreen() {
    this.flow.currentStep = 1
    this.ui.splashScreen.animateOut().then(() => {
      this.ui.assemble.animateIn()
    })
  }

  showEndScreen() {
    this.flow.currentStep = 2
    this.ui.assemble.animateOut().then(() => {
      this.ui.end.animateIn()
    })
  }

  setSelection(selection, carabiner_required, b2b) {
    const allModules = Object.keys(selection)

    const totalSelection = []
    allModules.forEach(module => {
      if (module == 'totalPrice') {
        return
      }

      if (!carabiner_required && module == 'carabiner') {
        return
      }

      const item = selection[module]
      this.finalSelection.push(item)
      totalSelection.push(item)
    })

    this.ui.end.setFinalPrice(selection.totalPrice)
    this.ui.end.renderSelection(totalSelection)

    // allow for basket module to be added
    if (carabiner_required && !b2b) {
      this.ui.end.setBasket(selection.color.basket)
    } else {
      this.ui.end.setBasket(false)
    }
  }

  disconnectedCallback() {}

  async addAllToCart() {
    if (this.b2b) {
      const products = {
        products: this.finalSelection.map(item => ({
          sku: item.variantSKU,
          absoluteQuantity: 1,
        })),
      }

      return await window.spark.updateCart(products)
    } else {
      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData()

      this.finalSelection.forEach(item => {
        formData.append('items[][id]', item.id)
        formData.append('items[][quantity]', 1)
      })

      config.body = formData

      try {
        const response = await fetch(`${routes.cart_add_url}`, config)
        const data = await response.json()
        this.ui.header.increaseCartQuantity(this.finalSelection.length)
        return data
      } catch (error) {
        console.log('error', error)
      }
    }
  }
}

if (!customElements.get('packbags-customiser')) {
  customElements.define('packbags-customiser', PackbagsCustomiser)
}
